export default __webpack_public_path__ + "static/low-code_Astrorei-ee798afe3fd8c22521225f8daf80c801.jpg";